<template>
  <div class="radio-input">
    <input :id :name :value type="radio" :checked="modelValue === value" class="hidden-radio" @change="modelValue = value" />
    <label :for="id" class="radio-input__label">
      <slot name="item" :checked="modelValue === value"></slot>
    </label>
  </div>
</template>

<script setup>
defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number],
    required: true,
  },
});

const modelValue = defineModel({ type: [String, Number], default: null });
</script>

<style scoped lang="scss">
.radio-input {
  .radio-input__label {
    cursor: pointer;
  }
}

.hidden-radio {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
